import { useEffect, useState } from 'react';
import Backdrop from '@mui/material/Backdrop';
import litvikLogo from '../img/litvik_logo.jpg';
import './LoadingOverlay.css';

function formatElapsed(totalSeconds) {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes < 1) {
    return `${seconds}s`;
  }
  return `${minutes}m ${String(seconds).padStart(2, '0')}s`;
}

export default function LoadingOverlay({ inProgress, active }) {
  const open = Boolean(inProgress || active);
  const [progress, setProgress] = useState(0);
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!open) {
      setProgress(0);
      setElapsed(0);
      return undefined;
    }

    const started = Date.now();
    setProgress(8);
    setElapsed(0);

    const timer = window.setInterval(() => {
      const seconds = (Date.now() - started) / 1000;
      setElapsed(Math.floor(seconds));
      const next = 92 * (1 - Math.exp(-seconds / 8));
      setProgress(Math.max(8, Math.min(92, next)));
    }, 200);

    return () => window.clearInterval(timer);
  }, [open]);

  const percent = Math.round(progress);

  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: 2000,
        backgroundColor: 'rgba(15, 23, 42, 0.45)',
      }}
    >
      <div className="litvik-loader" role="status" aria-live="polite" aria-busy={open}>
        <div className="litvik-loader__mark">
          <span className="litvik-loader__ring" />
          <img src={litvikLogo} alt="" className="litvik-loader__logo" />
        </div>
        <div
          className="litvik-loader__track"
          role="progressbar"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={percent}
        >
          <div className="litvik-loader__bar" style={{ width: `${percent}%` }} />
        </div>
        <p className="litvik-loader__label">Opening page... {percent}%</p>
        <p className="litvik-loader__time">{formatElapsed(elapsed)}</p>
      </div>
    </Backdrop>
  );
}
